import { useAppDispatch } from '@/store/store';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';

import { Switch } from '@headlessui/react';
import { setChangeIsOpen } from '@/store/slices/casesSlice';

const CasesSwitch = () => {
  const dispatch = useAppDispatch();
  const isOpen = useSelector((state: RootState) => state.cases.isOpen);

  return (
    <div className="flex items-center space-x-6 mb-5">
      <span
        className={`text-base font-jostExtraBold font-semibold ${
          !isOpen ? 'text-gray-900' : 'text-gray-500'
        }`}>
        ÅBEN
      </span>
      <Switch
        checked={isOpen}
        onChange={(val) => dispatch(setChangeIsOpen(val))}
        className="relative inline-flex w-16 h-4 items-center rounded-full bg-[#8CA2CE] transition-colors cursor-pointer">
        <span
          className={`${isOpen ? 'translate-x-12' : '-translate-x-2'}
            inline-block w-[26px] h-[26px] transform rounded-full bg-[#1F2B40] transition`}
        />
      </Switch>
      <span
        className={`text-base font-jostExtraBold font-semibold ${
          isOpen ? 'text-gray-900' : 'text-gray-500'
        }`}>
        AFSLUTTET
      </span>
    </div>
  );
};

export default CasesSwitch;
